import React, { FC, useEffect, useRef } from 'react';
import Chart from '@astrodraw/astrochart';
import { Horoscope, Origin } from 'circular-natal-horoscope-js';
import { primary } from 'styles/colors';

interface BirthChartProps {
  year: number;
  month: number;
  day: number;
  hour: number;
  minute: number;
  latitude: number;
  longitude: number;
  color: string;
  width: number;
  height: number;
  divId?: string;
}

const BirthChart: FC<BirthChartProps> = ({
  year,
  month,
  day,
  hour,
  minute,
  latitude,
  longitude,
  color = '#ECC192',
  width,
  height,
  divId = 'paper',
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const origin = new Origin({
      year: year,
      month: month - 1, // 0 = January, 11 = December! That's why -1.
      date: day,
      hour: hour,
      minute: minute,
      latitude: latitude,
      longitude: longitude,
    });

    const horoscope = new Horoscope({
      origin,
    });

    const planets = horoscope.CelestialBodies;

    const houses = horoscope.Houses.map(c => {
      const degree = c.ChartPosition.StartPosition.Ecliptic.DecimalDegrees;
      return degree;
    });

    const PRIMARY_COLOR = color;
    const SECONDARY_COLOR = color;

    const chart = new Chart(divId, 800, 800, {
      SIGNS_COLOR: PRIMARY_COLOR,
      SYMBOL_AXIS_FONT_COLOR: PRIMARY_COLOR,
      CIRCLE_COLOR: SECONDARY_COLOR,
      POINTS_COLOR: PRIMARY_COLOR,
      LINE_COLOR: PRIMARY_COLOR,
      CUSPS_FONT_COLOR: SECONDARY_COLOR,
      COLOR_BACKGROUND: 'transparent',
      CUSPS_STROKE: 1,
      SYMBOL_AXIS_STROKE: 1,
      STROKE_ONLY: true,
    });

    const data = {
      planets: {
        Pluto: [planets.pluto.ChartPosition.Ecliptic.DecimalDegrees],
        Neptune: [planets.neptune.ChartPosition.Ecliptic.DecimalDegrees],
        Uranus: [planets.uranus.ChartPosition.Ecliptic.DecimalDegrees],
        Saturn: [planets.saturn.ChartPosition.Ecliptic.DecimalDegrees],
        Jupiter: [planets.jupiter.ChartPosition.Ecliptic.DecimalDegrees],
        Mars: [planets.mars.ChartPosition.Ecliptic.DecimalDegrees],
        Moon: [planets.moon.ChartPosition.Ecliptic.DecimalDegrees],
        Sun: [planets.sun.ChartPosition.Ecliptic.DecimalDegrees],
        Mercury: [planets.mercury.ChartPosition.Ecliptic.DecimalDegrees],
        Venus: [planets.venus.ChartPosition.Ecliptic.DecimalDegrees],
        Chiron: [planets.chiron.ChartPosition.Ecliptic.DecimalDegrees],
      },
      cusps: houses,
    };

    chart.radix(data).aspects();

    const birthChart = document.getElementById(divId);
    if (birthChart) {
      birthChart.style.display = 'none !important';
    }

    const svgElement = document.querySelector(`div#${divId} svg`);
    if (svgElement) {
      svgElement.style.width = `${width}px`;
      svgElement.style.height = `${height}px`;
    }
    return () => {
      // Cleanup chart before the next render
      if (birthChart) {
        birthChart.innerHTML = '';
      }
    };
  }, [year, month, day, hour, minute, latitude, longitude, color]);

  return <div id={divId} ref={chartRef} />;
};

export default BirthChart;
